export default __webpack_public_path__ + "static/media/virace.855df17c.svg";